// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"93":"list","180":"story"}[chunkId] || chunkId) + "-" + {"93":"5f7afe83b3f2cb78f0ab","180":"23d96b5de70b8da65e41","185":"31857c5e43ff4a40d50e"}[chunkId] + ".css";
};